import { environment } from '@teem/environments/environment';

export const DEFAULT_LOGO = `${environment.baseUrl}/storage/defaults/avatar.png`;

export const HIDE_PAYMENT_DATE = `2021-11-31`;

export const STORE_TYPE:any = {
	PRODUCT: 'product',
	SERVICE: 'service'
}
